import React from 'react'
import classNames from 'classnames'
import { LinkButton } from '@/atoms/Button'
import { GuildIcon } from '@/atoms/Icons/GuildIcon'
import { paths } from '@/constants/paths'
import { projectTypes } from '@/constants/projectTypes'
import { useTranslate } from '@/utils/translate/translate-client'

interface GuildSubscribeButtonProps {
  projectSlug: string
  className?: string
  projectType?: string
  onClick?: () => void
}

export const GuildSubscribeButton: React.FC<GuildSubscribeButtonProps> = ({
  className,
  projectSlug,
  projectType,
  onClick,
}) => {
  const { t } = useTranslate('common')

  return (
    <LinkButton
      className={classNames('py-3 px-10 md:w-fit fill-white hover:fill-black backdrop-blur-md', className)}
      href={`${paths.guild.join}/${projectSlug}`}
      onClick={onClick}
      variant="white"
      prefetch
      outline
    >
      <div className="relative flex w-full flex-row items-center justify-center">
        <GuildIcon size={24} color1="white" className="fill-inherit" />
        <div className="ml-2">
          {t('guildSubscribeButton', 'Watch full {{ type }}', {
            type: projectType === projectTypes?.series ? 'episode' : projectType,
          })}
        </div>
      </div>
    </LinkButton>
  )
}
